import type { SITE_MODULATION_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-modulations-card/site-modulations-card.fr.ts";

export const SITE_MODULATION_CARD_ENGLISH_LOCALE = {
  title: "Modulations",
  count: "Modulations count last 72h",
  availableSince: "Available since",
} satisfies typeof SITE_MODULATION_CARD_FRENCH_LOCALE;
